module.exports = __webpack_public_path__ + "img/vip3.61b2b7d5.png";